import React, { useEffect, useState } from "react";
import { Languages } from "lucide-react";

const LANGS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "or", label: "ଓଡ଼ିଆ" },
  { code: "bn", label: "বাংলা" },
  { code: "ta", label: "தமிழ்" },
  { code: "te", label: "తెలుగు" },
  { code: "kn", label: "ಕನ್ನಡ" },
  { code: "ml", label: "മലയാളം" },
  { code: "mr", label: "मराठी" },
  { code: "gu", label: "ગુજરાતી" },
  { code: "as", label: "অসমীয়া" },
  { code: "pa", label: "ਪੰਜਾਬੀ" },
];

const INCLUDED = LANGS.filter((l) => l.code !== "en").map((l) => l.code).join(",");

function loadGoogleTranslate() {
  if (document.getElementById("google-translate-script")) return;
  window.googleTranslateElementInit = () => {
    if (window.google && window.google.translate) {
      // eslint-disable-next-line new-cap
      new window.google.translate.TranslateElement(
        { pageLanguage: "en", includedLanguages: INCLUDED, autoDisplay: false },
        "google_translate_element"
      );
    }
  };
  const s = document.createElement("script");
  s.id = "google-translate-script";
  s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  document.body.appendChild(s);
}

function setGoogTransCookie(lang) {
  const val = `/en/${lang}`;
  const host = window.location.hostname;
  const expire = lang === "en" ? "Thu, 01 Jan 1970 00:00:00 UTC" : "";
  const base = lang === "en" ? `googtrans=;expires=${expire};` : `googtrans=${val};`;
  document.cookie = `${base}path=/`;
  document.cookie = `${base}path=/;domain=${host}`;
  document.cookie = `${base}path=/;domain=.${host}`;
}

function applyToCombo(lang) {
  const combo = document.querySelector(".goog-te-combo");
  if (!combo) return false;
  combo.value = lang === "en" ? "" : lang;
  combo.dispatchEvent(new Event("change"));
  return true;
}

export default function LanguageSwitcher({ testid = "language-select" }) {
  const [lang, setLang] = useState(() => localStorage.getItem("site_lang") || "en");

  useEffect(() => {
    loadGoogleTranslate();
    if (lang === "en") return undefined;
    let tries = 0;
    const t = setInterval(() => {
      if (applyToCombo(lang) || ++tries > 60) clearInterval(t);
    }, 300);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const change = (e) => {
    const l = e.target.value;
    setLang(l);
    localStorage.setItem("site_lang", l);
    setGoogTransCookie(l);
    if (l === "en") {
      window.location.reload();
      return;
    }
    if (!applyToCombo(l)) {
      loadGoogleTranslate();
      let tries = 0;
      const t = setInterval(() => {
        if (applyToCombo(l) || ++tries > 60) clearInterval(t);
      }, 300);
    }
  };

  return (
    <div className="inline-flex items-center gap-1.5" translate="no">
      <div id="google_translate_element" className="hidden" />
      <Languages size={15} className="text-brand shrink-0" />
      <select
        value={lang}
        onChange={change}
        data-testid={testid}
        aria-label="Select language"
        className="notranslate h-8 rounded-full border border-line bg-paper text-xs font-semibold text-ink px-2 pr-6 focus:outline-none focus:border-brand cursor-pointer"
      >
        {LANGS.map((l) => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </div>
  );
}
